import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "../../data/site";

const LINKS = [
  { label: "Experience", id: "experience" },
  { label: "Menu", id: "menu" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export const Navbar = ({ onReserve, scrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass py-3" : "py-5 bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3"
        >
          <img src={LOGO} alt="Black Rose Lounge" className="h-9 w-auto" />
          <span className="font-display text-xl tracking-wide text-[var(--br-cream)] hidden sm:block">
            Black Rose <span className="text-[var(--br-gold)]">Lounge</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-sm tracking-wide text-[var(--br-muted)] hover:text-[var(--br-cream)] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-reserve-btn"
            onClick={onReserve}
            className="gold-btn rounded-full px-6 py-2.5 text-sm font-semibold tracking-wide"
          >
            Reserve Now
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[var(--br-cream)]"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden overflow-hidden glass mt-3 mx-4 rounded-2xl"
          >
            <div className="flex flex-col p-5 gap-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => { scrollTo(l.id); setOpen(false); }}
                  className="text-left text-[var(--br-muted)] hover:text-[var(--br-cream)] transition-colors"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-reserve-btn"
                onClick={() => { onReserve(); setOpen(false); }}
                className="gold-btn rounded-full px-6 py-3 text-sm font-semibold mt-2"
              >
                Reserve Now
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
